import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/cormorant-garamond';
import '@fontsource-variable/manrope';
import 'maplibre-gl/dist/maplibre-gl.css';
import './i18n';
import './styles.css';
import App from './App';
import { NarrationProvider } from './audio/NarrationProvider';
import { NarrationDock } from './audio/NarrationDock';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <NarrationProvider>
        <App />
        <NarrationDock />
      </NarrationProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
